<template>
    <div>
        Please use <a :href="loginOIDCUrl">the Login link</a> if you aren't forwarded to login page.
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import queryString from 'querystring';

export default {
    computed: {
        ...mapState('context', ['loginRedirectUrl']),

        returnPath() {
            let returnPath = this.$route.query.returnPath || '/';
            if (returnPath === '/auth-openid/login') returnPath = '/';
            return returnPath;
        },
        loginOIDCUrl() {
            this.setCurrentLoginMethod('auth-openid');
            const query = queryString.stringify({ returnPath: this.returnPath });

            return `${this.loginRedirectUrl}/api/auth-openid/login?${query}`;
        },
    },

    created() {
        window.location.href = this.loginOIDCUrl;
    },

    methods: {
        ...mapActions('context', ['setCurrentLoginMethod']),
    },
};
</script>
